import {createGlobalStyle} from 'styled-components';
import sprite from '../assets/mypartner-sprite.png';
import reportingSprite from '../assets/reporting-sprite.png';
import aiSprite from '../assets/aiSprite.png';
import mypSprite from '../assets/myp-sprite.png';
export const GlobalStyles = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap');

html {
  font-size: 10px;
  scroll-behavior: smooth;
}

/* to enable native scrolling for browsers which support native scrolling
  ( https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView )
  as well as to allow 'scroll-container' class elements to allow native scrolling (this is useful for 'smooth-scroll-into-view-if-needed' package)
 */
html, .scroll-container {
  overflow-y: scroll;
}

html.modal-open {
  overflow: hidden;
}

body.moda-open {
  overflow: inherit;
}

*,

*:before,

*:after {

-webkit-font-smoothing: antialiased;

}

/* This senses uses's OS's native preferences for scroll, if someone has turned off
  they won't see scroll animation
 */
@media (prefers-reduced-motion) {
  html,
  .scroll-container {
    scroll-behavior: auto;
  }
}

*{
    padding:0;
    margin:0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-family: 'Lato', sans-serif;
}

.headerBox{
  z-index:99;
}

.oh {
  height: 100vh;
  overflow-y: hidden;
}

body{
    font-family: 'Lato';
    background: #f2f2f2;
    color: #141823;
    font: 400 1.2rem/1.33 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}


/* loyality pages */
.container{
	max-width: 1200px;
	margin: 0 auto;
  & img{
    max-width:100%;
  }

  ul {
    margin: 0;
    list-style: none;
  }
  
}

html.noScroll{
  overflow: hidden;
}

.fixed {
  overflow: hidden;
  /* position: fixed; */
}

/* Sprite Icons */
.sprite{
	background: url(${sprite}) no-repeat; 
	display: inline-block; 
	background-size: 200px 350px; 
	font-size: 0px; 
	flex-shrink: 0;
}
.reportSprite{
	background: url(${reportingSprite}) no-repeat; 
  width:150px;
  height:150px;
  background-size:150px 150px;
  display:flex;
}
.mypSprite{
  background: url(${mypSprite}) no-repeat; 
	display: inline-block; 
	background-size: 200px 300px; 
	font-size: 0px; 
	flex-shrink: 0;
}
.rightArrowIcon{
  background-position: -66px -57.5px;;
              
  width: 8px;
  height: 7px;
  display:inline-block;
}

.sprite.icInfoYellow{
  background-position: -96px -209px;
  width: 29px;
  height: 29px;
}

.sprite.icInfoRed{
 background-position: -157px -173px;
  width: 27px;
  height: 27px;
}
.sprite.icExclaimRedBg{
 background-position: -155px -207px;
 width: 20px;
 height: 20px;
}
.sprite.icBin{
 background-position: -178px -205px;
 width: 14px;
 height: 15px;
}
.sprite.icEditHollow{
 background-position: -179px -244px;
 width: 14px;
 height: 14px;
}
.sprite.icGreenBgTick{
 background-position: -180px -225px;
 width: 14px;
	height: 14px;
}



.sprite.icInfoWhite{
  background-position: -182px -149px;
  width: 15px;
 height: 15px;
}
.sprite.icSuccess{
  background-position: -4px -244px;
  width: 170px;
  height: 89px;
  }
  .sprite.icClose{
    width: 19px;
    height: 19px;
    background-position: -129px -214px;
}
 
 
.reportIcon{
  width: 15px;
  height: 18px;
  background-position: -2px -2px;
}

.gstIcon{
  width: 19px;
  height: 19px;
  background-position: -20px -2px;
}
.ic_my{
	width: 27px;
	height: 26px;
	background-position: -6px -6px;
}
.ic_tick{
	width: 32px;
	height: 32px;
	background-position: -121px -171px;
}
.ic_tickWhite{
	width: 32px;
	height: 32px;
	background-position: -79px -134px;;
}
.ic_goldenArrow{
	width: 17px;
	height: 22px;
	background-position: -40px -9px;
}
.ic_heroText{
	width: 38px;
	height: 12px;
	background-position: -109px -6px;
}
.ic_goldCoinsText{
	width: 55px;
    height: 25px;
    background-position: -34px -208px;
}
.ic_deposit{
	width: 25px;
	height: 23px;
	background-position: -169px -5px;
}
.ic_deposit_purple{
	width: 20px;
    height: 24px;
    background-position: -53px -140px;
}
.ic_notFound{
	width: 37px;
	height: 28px;
	background-position: -5px -49px;
}
.ic_graphDefault{
	width: 21px;
	height: 15px;
	background-position: -54px -42px;
}
.ic_graphActive{
	width: 21px;
	height: 15px;
	background-position: -54px -62px;
}
.ic_listDefault{
	width: 21px;
	height: 15px;
	background-position: -84px -42px;
}
.ic_listActive{
	width: 21px;
	height: 15px;
	background-position: -84px -62px;
}
.ic_support{
	width: 25px;
	height: 32px;
	background-position: -111px -41px;
}
.ic_support_purple{
	width: 20px;
    height: 30px;
    background-position: -3px -137px;
}
.ic_cashback{
	width: 25px;
	height: 28px;
	background-position: -143px -42px;
}
.ic_cashback_purple{
	width: 20px;
	height: 22px;
	background-position: -29px -141px;
}
.ic_onwayArrow{
	width: 9px;
	height: 4px;
	background-position: -20px -85px;
}
.ic_roundTripArrow{
	width: 9px;
	height: 8px;
	background-position: -5px -85px;
}
.ic_cap{
	width: 15px;
	height: 15px;
	background-position: -177px -41px;
}
.ic_grayInfo{
	width: 15px;
	height: 15px;
	background-position: -177px -59px;
}
.ic_mmtCircle{
	width: 25px;
	height: 24px;
	background-position: -173px -80px;
}

/* back arrow */
.backArrow {
	content: "";
	display: inline-flex;
	border: solid #000000;
	border-width: 0 2px 2px 0;
	padding: 3px;
	transform: rotate(135deg);
}
.sprite.icMinus{
  width:16px;
  height:16px;
  background-position: -102px -77px;
}
.sprite.icUpload{
  width:19px;
  height:16px;
  background-position: -121px -78px;
}
.sprite.icSearchBlue{
  width:14px;
  height:14px;
  background-position: -144px -78px;
}
.sprite.icPdf{
  width:30px;
  height:37px;
  background-position: -2px -94px;
}
.sprite.icCalendar{
  width:18px;
  height:18px;
  background-position: -165px -78px;
}
.sprite.icImage{
  width:36px;
  height:36px;
  background-position: -37px -95px;
}
.aiSprite.nameUploadIcon{
  width: 16px;
	height: 14px;
  background-position: -19px -2px;
}
.makeFlex.hrtlCenter {
    align-items: center;
	display: flex;
}
.greyText {
    color: #9b9b9b;
}
.font12 {
    font-size: 12px;
    line-height: 14px;
}
.blueText {
  color: #008cff;
  cursor: pointer;
}
.append19Top{
    margin-top: 19px;
}
.noShrink {
	flex-shrink: 0;
}
.appendRight10 {
	margin-right: 10px;
}
.appendLeft10 {
	margin-left : 10px;
}
.appendLeft16 {
	margin-left : 16px;
}
.appendTop30{
    margin-top: 20px;
}
.appendTop40 {
    margin-top: 40px;
}
.appendTop16 {
	margin-top: 16px;
}
.padding10 {
	padding: 0px 10px;
    margin-bottom: 10px;
}
main, .container{
	margin:0 auto;
	max-width:1200px;
}
main{
	display:flex;
  margin-bottom: 25px;
}
.fw100 
  font-weight: 100 !important;
}
.mr4 {
  margin-right: 4px;
}
.latoBlack20 {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}
.latoBlack16 {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}
.latoBlack11 {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 12px;
  color: #4A4A4A;
}

.font18{
  font-size:18px;
  line-height:18px;
}
.font26{
    font-size:26px;
    line-height:26px;
}
.latoBlack{
  font-weight:800;
}

.textDecorationNone{
  text-decoration:none;
}
.width100{
  //width:100vw;
}

.mypSprite.ic_rupee{
	width: 22px;
	height: 23px;
	background-position: -141px -130px;
}
.mypSprite.ic_mypFlight{
	width: 33px;
	height: 33px;
	background-position: -130px -96px;
}
.mypSprite.ic_mypHotel{
	width: 32px;
	height: 32px;
	background-position: -166px -106px;
}
.mypSprite.ic_rewardLock{
	width: 23px;
	height: 23px;
	background-position: -174px -141px;
}

.mypSprite.ic_rewardUnlock{
	width: 23px;
	height: 23px;
	background-position: -174px -166px;
}

.mypSprite.ic_report{
  width:33px;
  height:32px;
  background-position:-104px -155px;
}
.mypSprite.ic_userSettings{
  width:18px;
  height:24px;
  background-position:-64px -129px;
}
.mypSprite.ic_userIcon{
  width:33px;
  height:32px;
  background-position: -1px -156px;
}
.mypSprite.ic_handBag{
  width:33px;
  height:32px;
  background-position:-36px -155px;
}
.mypSprite.ic_wallet{
  width:33px;
  height:32px;
  background-position: -138px -155px;
}
.mypSprite.ic_logOut{
  width:33px;
  height:32px;
  background-position: -70px -155px;
}
.mypSprite.ic_markUp{
  width:18px;
  height:24px;
  background-position: -89px -131px;
}
  .mypSprite.manageDevices{
    background-position: -1px -191px;
    width: 32px;
    height: 32px;
  }
	.mypSprite.helpDesk{
  background-position: -35px -190px;
	width: 32px;
	height: 32px;

  }
/* Colors */
    .grey{ color: #757575;}
    .blackText{ color: #000;}
    .blueText{ color: #008CFF;}
    .blackText{ color: #000;}

    /* font size */
    .fs10{ font-size: 10px; line-height: 12px;}
    .fs12{ font-size: 12px; line-height: 14px;}
    .fs14{ font-size: 14px; line-height: 16px;}
    .fs16{ font-size: 16px; line-height: 18px;}
    .fs18{ font-size: 18px; line-height: 20px;}
    .fs20{ font-size: 20px; line-height: 22px;}
    .fs22{ font-size: 22px; line-height: 24px;}
    .fs24{ font-size: 24px; line-height: 26px;}
    .fs26{ font-size: 26px; line-height: 28px;}
    .fs28{ font-size: 28px; line-height: 30px;}
    .fs30{ font-size: 30px; line-height: 32px;}
    .fs32{ font-size: 32px; line-height: 34px;}

    /* margin bottom */
    .mb5{ margin-bottom: 5px;}
    .mb8{ margin-bottom: 8px;}
    .mb10{ margin-bottom: 10px;}
    .mb15{ margin-bottom: 15px;}
    .mb20{ margin-bottom: 20px;}

    /* margin left */
    .ml3{margin-left: 3px;}
    .ml5{ margin-left: 5px;}
    .ml10{ margin-left: 10px;}
    .ml15{ margin-left: 15px;}
    .ml20{ margin-left: 20px;}
    .ml24{ margin-left: 24px;}

    /* margin right */
    .mr3{ margin-right: 3px;}
    .mr5{ margin-right: 5px;}
    .mr10{ margin-right: 10px;}
    .mr12{ margin-right: 12px;}
    .mr15{ margin-right: 15px;}
    .mr20{ margin-right: 20px;}
    
    /* margin top */
    .mt3{ margin-top: 3px;}
    .mt5{ margin-top: 5px;}
    .mt10{ margin-top: 10px;}
    .mt15{ margin-top: 15px;}
    .mt20{ margin-top: 20px;}
    .mt24{ margin-top: 24px;}
    .mt30{ margin-top: 30px;}

    /* Span margin and Pading class */
    .mgPd {
      display: inline-block;
    }

	/* Flex */
    .flex{ display: flex;}
    .column{ flex-direction: column;}
    .hCenter{ align-items: center;}
    .vCenter{ justify-content: center;}
    .hvCenter{ align-items: center; justify-content: center;}
    .noShrink{ flex-shrink: 0;}

    /*Primary Button*/
    .primaryBtn {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      border-radius: 8px;
      border: 1px solid #008CFF;
      color: #008CFF;
      font-size: 14px;
      line-height: 20px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: auto;
      cursor: pointer;
    }



.pushRight {
  margin-left: auto;
}
.marginTop24{
  margin-top: 24px;
}
.fontGreen {
  font-size: 14px;
  line-height: 20px;
  font-weight: 900;
  color: #007E7D !important;
  margin-left: 8px;
}
.marginLeft12{
  margin-left: 12px;
}
.marginRight12{
  margin-right: 12px;
}
.marginTop24 {
  margin-top:24px;
  display: flex;
}
.pageRow {
  margin-bottom: 16px;
  border-bottom: 1px solid #D8D8D8;
  padding: 8px 8px 16px 8px;
}
.pageLastRow {
  padding: 8px 8px 16px 8px;
}
.aiSprite{
  background: url(${aiSprite}) no-repeat;  
  background-size: 100px 300px;
  display: flex;
  font-size: 0px;
  flex-shrink: 0;
}
.aiSprite.aisGreenTickIcon {
    width: 20px;
    height: 20px;
    background-position: -2px -127px;
}
.aiSprite.aisGreenTickIcon{
  width: 20px;
	height: 20px;
  background-position: -2px -127px;
}

.aiSprite.aisGreyTickIcon{
  width: 20px;
	height: 20px;
  background-position: -52px -93px;
}

.aiSprite.aisYellowExclaimation{
  width: 28px;
	height: 28px;
  background-position:-50px -120px;
}
.aiSprite.aisProfile{
  width: 15px;
  height: 15px;
  background-position:-82px -127px;
}
.aiSprite.aisBankIcon {
    width: 14px;
    height: 17px;
    background-position: -29px -128px;
}
.aisAddBtn {
  color: #008CFF;
  text-decoration: none;
  cursor: pointer;
  border: none !important;
  padding: 0 !important;
  margin-left: 0;
  font-size: 16px !important;
}
.primaryBtn.aisModalBtn {
    border: none !important;
    padding: 16px !important;
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 900 !important;
    color: white !important;
    background: linear-gradient(93.66deg, #3543BF 0%, #3543BF 100%) !important;
    margin: auto;
    width: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
}
.aiSprite.aisRedCrossIcon {
    width: 20px;
    height: 20px;
    background-position: -77px -95px;
}
.regularActnBtn {
    border: none !important;
    padding: 10px 16px !important;
    font-size: 16px !important;
    line-height: 24px !important;
    font-weight: 900 !important;
    color: #FFFFFF !important;
    background: linear-gradient(
    93.66deg
    , #3543BF 0%, #3543BF 100%) !important;
}
.alignLeft {
  margin-left: auto;
}
.primaryBtn.disabledBtn {
    border: none !important;
    cursor: not-allowed;
    background: #757575 !important;
    color: #FFFFFF !important;
}
`;
